<template>
    <lsn-table :data="monthlySummaries" class="sl-monthly-summaries">
        <template #subtable-caption>
            {{ $t("invoicing.monthly_summaries.table.title") }}
        </template>

        <!-- Header -->
        <template #header>
            <lsn-table-cell class="sl-monthly-summary__date">
                {{ $t("invoicing.table.headers.date") }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-monthly-summary__reference">
                {{ $t("invoicing.table.headers.reference") }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-monthly-summary__total">
                {{ $t("invoicing.table.headers.total_excl_taxes") }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-monthly-summary__currency">
                {{ $t("invoicing.table.headers.currency") }}
            </lsn-table-cell>

            <lsn-table-cell class="sl-monthly-summary__actions" />
        </template>

        <template #summary="{ item }">
            <monthly-summary-line-summary :monthly-summary="item" />
        </template>

        <template #details="{ item }">
            <invoice-line-details :invoice="item" />
        </template>
    </lsn-table>
</template>

<script>
import LsnTable from '@/components/LsnTable/LsnTable.vue';
import LsnTableCell from '@/components/LsnTable/LsnTableCell.vue';
import MonthlySummaryLineSummary from '@/components/monthly-summary/MonthlySummaryLineSummary.vue';
import InvoiceLineDetails from '@/components/invoice/InvoiceLineDetails.vue';

export default{
    name: "MonthlySummaryTable",

    components:
    {
        LsnTable,
        LsnTableCell,
        MonthlySummaryLineSummary,
        InvoiceLineDetails,
    },

    props:
    {
        monthlySummaries:
        {
            type:     Array,
            required: true,
        },
    },
};
</script>

<style>
@reference "#main.css";

.sl-monthly-summaries
{
    --column-width: 140px;
    --small-column-width: 100px;
}

.lsn-table.lsn-table--openable.sl-monthly-summaries > .lsn-table__header,
.lsn-table.lsn-table--openable.sl-monthly-summaries > .lsn-table__body > .lsn-table__line > .lsn-table__line-summary
{
    display: grid;
    grid-template-columns:
        var(--open-toggle-width) /* chevron */
        var(--column-width) /* date */
        var(--column-width) /* reference */
        var(--column-width) /* amount */
        var(--small-column-width) /* currency */
        auto; /* empty space */
}

.lsn-table:not(.lsn-table--openable).sl-monthly-summaries > .lsn-table__header,
.lsn-table:not(.lsn-table--openable).sl-monthly-summaries > .lsn-table__body > .lsn-table__line > .lsn-table__line-summary
{
    display: grid;
    grid-template-columns:
        var(--column-width) /* date */
        var(--column-width) /* reference */
        var(--column-width) /* amount */
        var(--small-column-width) /* currency */
        auto; /* empty space */
}

.sl-monthly-summary__total,
.sl-monthly-summary__actions
{
    @apply text-right;
}

.sl-monthly-summary__currency
{
    @apply text-center;
}
</style>
